var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-download"},[_c('img',{attrs:{"src":require("@/assets/invite/pic@2x.png")}}),_c('div',{staticClass:"down-btn",on:{"click":_vm.handelDownload}})])}
var staticRenderFns = []

export { render, staticRenderFns }